module.exports = __webpack_public_path__ + "static/media/camera.9f9cc0c3.svg";